import callAPI from '../ApiConfig'


const dashboard = async (props) => {


    return await callAPI({
        route: "transactions/dashboard",
        method: "get",
        signal: props?.signal,
        params: props?.params,
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        }
    })

}

const getWeightTotalsPerMizan = async (props) => {
    return await callAPI({
        route: "transactions/weight_totals_per_mizan",
        method: "get",
        signal: props?.signal,
        params: props?.params,
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        }
    })
}

const createAdjustmentTransaction = async (props) => {
    return await callAPI({
        route: "transactions/adjustment",
        method: "post",
        signal: props?.signal,
        params: props?.params,
        data: props?.data,
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        }
    })
}

const getMizanWeightDifferenceAtDate = async (props) => {
    return await callAPI({
        route: "transactions/mizan_weight_difference",
        method: "get",
        signal: props?.signal,
        params: props?.params,
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        }
    })
}

const dashboardAPI = {
    dashboard: dashboard,
    getWeightTotalsPerMizan: getWeightTotalsPerMizan,
    createAdjustmentTransaction: createAdjustmentTransaction,
    getMizanWeightDifferenceAtDate: getMizanWeightDifferenceAtDate
}
export default dashboardAPI